import { DropdownContext } from '@components/DropdownContext';
import { cnMixSpace, IconArrowDown } from '@uikit';

import { useState } from 'react';

import { CatalogUerBaseCostMassUploadModal } from './CatalogUerBaseCostMassUploadModal';
import { CatalogUERIdWithDisabledWorkScopes, massUploadItems, MassUploadType } from './models/constants';

export const CatalogUerBaseCostMassUpload = ({
    catalogId,
    onSuccessAction,
    disabled,
}: {
    catalogId: number;
    onSuccessAction: () => void;
    disabled: boolean;
}) => {
    const [selectedItem, setSelectedItem] = useState<MassUploadType | null>(null);

    const handleOpenModal = (value: MassUploadType) => {
        setSelectedItem(value);
    };

    const handleCloseModal = () => {
        setSelectedItem(null);
    };

    const dropdownItems = massUploadItems.map((item) => ({
        label: item.label,
        value: item.value,
        action: () => handleOpenModal(item.value),
        disabled:
            item.value === MassUploadType.WorkScopes ? CatalogUERIdWithDisabledWorkScopes.includes(catalogId) : false,
    }));

    return (
        <>
            <DropdownContext
                items={dropdownItems}
                btnView="secondary"
                btnSize="s"
                btnIconSize="s"
                btnLabel="Массовая загрузка"
                icon={IconArrowDown}
                wrapperClassName={cnMixSpace({
                    mL: 's',
                })}
                isDropdownWidthMatchBtn
                isDisabled={disabled}
            />

            {selectedItem && (
                <CatalogUerBaseCostMassUploadModal
                    key={selectedItem}
                    uploadType={selectedItem}
                    onClose={handleCloseModal}
                    catalogId={catalogId}
                    onSuccessAction={onSuccessAction}
                />
            )}
        </>
    );
};

CatalogUerBaseCostMassUpload.displayName = 'CatalogUerBaseCostMassUpload';
